import { useEffect } from "react";
import Router from "next/router";
import nextCookie from "next-cookies";
import Cookies from "js-cookie";
import { setItemWithExpiry } from "../utils/localstorage";

export const login = ({ token, queryParam }) => {
  const day = 7;
  Cookies.set("token", token, { expires: day, path: "/" });
  const storage_day = day * 24 * 60 * 60 * 1000;
  setItemWithExpiry("token", token, storage_day);

  const redirect_url = Cookies.get("redirect_url");
  Cookies.remove("redirect_url");

  if (redirect_url)
    Router.push(`${redirect_url}${queryParam ? `?${queryParam}` : ``}`);
  else Router.push(`/${queryParam ? `?${queryParam}` : ``}`);
};

export const auth = async (ctx) => {
  const { token } = nextCookie(ctx);

  // If there's no token, it means the user is not logged in.
  if (!token) {
    if (typeof window === "undefined") {
      if (ctx.res) {
        ctx.res.writeHead(302, { Location: "/signup" });
        ctx.res.end();
      }
    } else {
      Router.push("/signup");
    }
  }

  return token;
};

export const logout = async () => {
  Cookies.remove("token");
  localStorage.removeItem("token");
  Router.push("/signup");
};
